/* eslint-disable react/jsx-key */
import React, { Fragment } from 'react';
import FilterVector from '@/assets/images/svg/FilterVector';
import { Button, Loading } from '@/components';
import { Container, Label } from 'reactstrap';
import { RegisterContent } from '@/features/contractor/components/RegisterContent';
import { ReactComponent as ItemConfig } from '@/assets/images/svg/ItemConfig.svg';
import { ReactComponent as Money } from '@/assets/images/svg/reMoney.svg';
import { ReactComponent as Status } from '@/assets/images/svg/status.svg';
import { ReactComponent as Pen } from '@/assets/images/svg/pen.svg';
import { ReactComponent as Trash } from '@/assets/images/svg/lixeira.svg';
import { ReactComponent as RecoverPassword } from '@/assets/images/svg/reload-password.svg';
import { ActionProps, Dialog } from '@/components/Dialog';
import { ColumnStatus, CustomTable } from '@/components/Table';
import Pagination from '@/components/Utils/Pagination';
import Contractor from '@/model/Contractor';
import {
  BanckAccountForm,
  ContractorControllerBankAccount,
  ContractorControllerUser,
  ContractorRequestParams,
} from '@/features/contractor/types';
import { FilterContent } from '@/features/contractor/components/FilterContent';
import { FormErrors, OnChangeFormInput, FormData } from '@/hooks/useForm';
import { RegisterBankAccount } from '@/features/contractor/components/RegisterBankAccount';
import { RegisterPix } from '@/features/contractor/components/RegisterPix';
// import ContractorType from '@/model/ContractorType';
import { colors } from '@/styles/colors';
import Pix from '@/model/Pix';
import Bank from '@/model/Bank';
import { FeeContent } from '@/features/contractor/components/FeeContent';
import { TaxesContent } from '@/features/contractor/components/TaxesContent';
import { columnsContractor } from './table';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}
export interface DataRowContractor {
  id: string;
  name: string;
  document: string;
  telephone: string;
  companyType: number;
  actions: string;
}

export interface DataRowBankAccount {
  id: number;
  name: string;
  agencia: string;
  conta: string;
  actions: string;
}

export interface DataRowPix {
  id: number;
  name: string;
  type: string;
  pix: string;
  actions: string;
}

export interface DataRowUser {
  id: number;
  name: string;
  login: string;
  actions: string;
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
  registerContractor = 'registerContractor',
  registerBankAccount = 'registerBankAccount',
  registerPix = 'registerPix',
  fee = 'fee',
  taxes = 'taxes',
}

interface ContractorContainerProps {
  state: States;
  contractorState: Contractor | undefined;
  listContractor: Contractor[];
  currentPage: ContractorRequestParams;
  shouldShowModal: ShouldShowModal;
  title: string | React.ReactNode;
  visible: boolean;
  formDataContractor: FormData;
  formErrorsContractor: FormErrors;
  toggleReportPassword: boolean;
  toggleReversePassword: boolean;
  toggleBleedPassword: boolean;
  toggleCloseCashierPassword: boolean;
  toggleCourtesyPassword: boolean;
  toggleReprintPassword: boolean;
  toggleValidatorPassword: boolean;
  togglePdvReportPassword: boolean;
  banks: Bank[];
  formDataPix: FormData;
  formErrorsPix: FormErrors;
  formDataFee: FormData;
  formErrorsFee: FormErrors;
  formDataTaxes: FormData;
  formErrorsTaxes: FormErrors;
  formDataFilter: FormData;
  formErrorsFilter: FormErrors;
  listBankAccount: BanckAccountForm[];
  clearFilter: () => void;
  onSaveContractor: () => Promise<void>;
  onSaveBankAccount: () => Promise<void>;
  onChangeFormInputPix: OnChangeFormInput;
  onSavePix: () => Promise<void>;
  onChangeFormInputFee: OnChangeFormInput;
  onSaveFee: () => Promise<void>;
  onChangeFormInputTaxes: OnChangeFormInput;
  onSaveTaxes: () => Promise<void>;
  onPaginationChange: (page: number) => void;
  changeColorColumn: (status: number) => void;
  onChangeFormInputFilter: OnChangeFormInput;
  onToggle: () => void;
  onFilter: () => Promise<void>;
  onChangeFormInputContractor: OnChangeFormInput;
  setToggleReportPassword: (show: boolean) => void;
  setToggleReversePassword: (show: boolean) => void;
  setToggleBleedPassword: (show: boolean) => void;
  setToggleCloseCashierPassword: (show: boolean) => void;
  setToggleCourtesyPassword: (show: boolean) => void;
  setToggleReprintPassword: (show: boolean) => void;
  setToggleValidatorPassword: (show: boolean) => void;
  setTogglePdvReportPassword: (show: boolean) => void;
  onShowDeleteContractor: (pos: Contractor) => void;
  onShouldShowModal: ({
    value,
    newTitleModal,
    contractor,
    pixIndex,
    isEdit,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    contractor?: Contractor;
    pixIndex?: number;
    isEdit?: boolean;
  }) => void;
  controllerInputAppendBankAccount: ContractorControllerBankAccount;
  onDeleteRowBankAccount: (bankAccount: BanckAccountForm) => void;
  pixs: Pix[];
  // listContractorType: ContractorType[];
  controllerAppendUser: ContractorControllerUser;
  onDeletePix: (index: number) => void;
  onReloadPassword: (contractorId: string) => void;
}

export const ContractorContainer: React.FC<ContractorContainerProps> = ({
  listContractor,
  // listContractorType,
  state,
  contractorState,
  currentPage,
  title,
  visible,
  shouldShowModal,
  formDataContractor,
  formErrorsContractor,
  toggleReportPassword,
  toggleReversePassword,
  toggleBleedPassword,
  toggleCloseCashierPassword,
  toggleCourtesyPassword,
  toggleReprintPassword,
  toggleValidatorPassword,
  togglePdvReportPassword,
  banks,
  formDataPix,
  formErrorsPix,
  formDataFee,
  formErrorsFee,
  formDataTaxes,
  formErrorsTaxes,
  formDataFilter,
  formErrorsFilter,
  listBankAccount,
  pixs,
  clearFilter,
  onChangeFormInputFilter,
  onChangeFormInputContractor,
  setToggleReportPassword,
  setToggleReversePassword,
  setToggleBleedPassword,
  setToggleCloseCashierPassword,
  setToggleCourtesyPassword,
  setToggleReprintPassword,
  setToggleValidatorPassword,
  setTogglePdvReportPassword,
  onSaveContractor,
  onSaveBankAccount,
  onChangeFormInputPix,
  onSavePix,
  onChangeFormInputFee,
  onSaveFee,
  onChangeFormInputTaxes,
  onSaveTaxes,
  onPaginationChange,
  changeColorColumn,
  onToggle,
  onFilter,
  onShouldShowModal,
  onShowDeleteContractor,
  controllerInputAppendBankAccount,
  controllerAppendUser,
  onDeleteRowBankAccount,
  onDeletePix,
  onReloadPassword,
}) => {
  const dataTableContractor = listContractor?.map(item => ({
    id: item.id,
    name: (
      <ColumnStatus statusColor={String(changeColorColumn(Number(item.status)))}>
        {item.name}
      </ColumnStatus>
    ),
    document: item.document,
    telephone: item.telephone,

    actions: (
      <React.Fragment>
        <RecoverPassword
          onClick={(): void => onReloadPassword(item.id)}
          className="mr-4 action-icon-password"
          style={{ cursor: 'not-allowed' }}
        />
        <ItemConfig
          className="mr-4 svg-icon action-icon"
          onClick={(): void => {
            onToggle();
            onShouldShowModal({
              value: ShouldShowModal.fee,
              newTitleModal: 'Configurações de taxas lançadas ao cliente final',
              contractor: item,
            });
          }}
        />
        <Money
          className="mr-4 svg-icon action-icon"
          onClick={(): void => {
            onToggle();
            onShouldShowModal({
              value: ShouldShowModal.taxes,
              newTitleModal: 'Configurações de taxas lançadas ao produtor',
              contractor: item,
            });
          }}
        />
        <Pen
          className="mr-4 svg-icon action-icon"
          onClick={(): void => {
            onToggle();
            onShouldShowModal({
              value: ShouldShowModal.registerContractor,
              newTitleModal: `${item.name}`,
              contractor: item,
            });
          }}
        />
        <Trash
          className="mr-2 svg-icon action-icon svg-icon-trash"
          onClick={() => {
            onShowDeleteContractor(item);
          }}
        />
      </React.Fragment>
    ),
  }));

  const renderActionDialogToCancel: ActionProps = {
    title: 'Cancelar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };
  const renderActionDialogToReturn: ActionProps = {
    title: 'Cancelar',
    onClick: (): void =>
      onShouldShowModal({
        value: ShouldShowModal.registerContractor,
        newTitleModal: contractorState?.id
          ? contractorState.name
          : 'Cadastrar nova empresa (contratante)',
        contractor: contractorState,
      }),
    theme: 'noneBorder',
  };
  const renderActionDialogToCancelFilter: ActionProps = {
    title: 'Limpar',
    onClick: (): void => clearFilter(),
    theme: 'noneBorder',
  };

  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        position={shouldShowModal === ShouldShowModal.filter ? 'right' : 'center'}
        isContentWithCard={shouldShowModal !== ShouldShowModal.filter}
        actions={[
          {
            [ShouldShowModal.filter]: renderActionDialogToCancelFilter,
            [ShouldShowModal.registerContractor]: renderActionDialogToCancel,
            [ShouldShowModal.registerBankAccount]: renderActionDialogToReturn,
            [ShouldShowModal.registerPix]: renderActionDialogToReturn,
            [ShouldShowModal.fee]: renderActionDialogToCancel,
            [ShouldShowModal.taxes]: renderActionDialogToCancel,
          }[shouldShowModal],
          {
            [ShouldShowModal.filter]: {
              title: 'Aplicar',
              onClick: (): Promise<void> => onFilter(),
            },
            [ShouldShowModal.registerContractor]: {
              title: contractorState?.id ? 'Salvar' : 'Cadastrar novo contratante',
              onClick: (): Promise<void> => onSaveContractor(),
              disabled:
                Object.keys(formErrorsContractor).length === 0 &&
                formErrorsContractor.constructor === Object,
            },
            [ShouldShowModal.registerBankAccount]: {
              title: 'Salvar',
              onClick: (): Promise<void> => onSaveBankAccount(),
              disabled: controllerInputAppendBankAccount.bankAccount.length === 0,
            },
            [ShouldShowModal.registerPix]: {
              title: 'Salvar',
              onClick: (): Promise<void> => onSavePix(),
            },
            [ShouldShowModal.fee]: {
              title: 'Salvar',
              onClick: (): Promise<void> => onSaveFee(),
            },
            [ShouldShowModal.taxes]: {
              title: 'Salvar',
              onClick: (): Promise<void> => onSaveTaxes(),
            },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.filter]: (
              <FilterContent
                formData={formDataFilter}
                formErrors={formErrorsFilter}
                onChangeFormInput={onChangeFormInputFilter}
              />
            ),
            [ShouldShowModal.registerContractor]: (
              <RegisterContent
                banks={banks}
                formData={formDataContractor}
                formErrors={formErrorsContractor}
                toggleReportPassword={toggleReportPassword}
                toggleReversePassword={toggleReversePassword}
                toggleBleedPassword={toggleBleedPassword}
                toggleCloseCashierPassword={toggleCloseCashierPassword}
                toggleCourtesyPassword={toggleCourtesyPassword}
                toggleReprintPassword={toggleReprintPassword}
                toggleValidatorPassword={toggleValidatorPassword}
                togglePdvReportPassword={togglePdvReportPassword}
                onChangeFormInput={onChangeFormInputContractor}
                setToggleReportPassword={setToggleReportPassword}
                setToggleReversePassword={setToggleReversePassword}
                setToggleBleedPassword={setToggleBleedPassword}
                setToggleCloseCashierPassword={setToggleCloseCashierPassword}
                setToggleCourtesyPassword={setToggleCourtesyPassword}
                setToggleReprintPassword={setToggleReprintPassword}
                setToggleValidatorPassword={setToggleValidatorPassword}
                setTogglePdvReportPassword={setTogglePdvReportPassword}
                pixs={pixs}
                contractorState={contractorState}
                // listContractorType={listContractorType}
                listBankAccount={listBankAccount}
                onShouldShowModal={onShouldShowModal}
                onDeleteRowBankAccount={onDeleteRowBankAccount}
                onDeleteRowPix={onDeletePix}
                controllerAppendUser={controllerAppendUser}
              />
            ),
            [ShouldShowModal.registerBankAccount]: (
              <RegisterBankAccount
                formErrors={formErrorsContractor}
                controllerInputAppendBankAccount={controllerInputAppendBankAccount}
              />
            ),
            [ShouldShowModal.registerPix]: (
              <RegisterPix
                banks={banks}
                formData={formDataPix}
                formErrors={formErrorsPix}
                onChange={onChangeFormInputPix}
              />
            ),
            [ShouldShowModal.fee]: (
              <FeeContent
                formData={formDataFee}
                formErrors={formErrorsFee}
                onChangeFormInput={onChangeFormInputFee}
              />
            ),
            [ShouldShowModal.taxes]: (
              <TaxesContent
                formData={formDataTaxes}
                formErrors={formErrorsTaxes}
                onChangeFormInput={onChangeFormInputTaxes}
              />
            ),
          }[shouldShowModal]
        }
      </Dialog>

      <Container className="mainContainer" fluid={true}>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '30px' }}>
          <div className="pageTitle" style={{ display: 'grid' }}>
            <Label>Contratantes</Label>
          </div>
          <div className="button-filter-container">
            <Button
              title="+ Cadastrar novo Contratante"
              onClick={(): void => {
                onToggle();
                onShouldShowModal({
                  value: ShouldShowModal.registerContractor,
                  newTitleModal: 'Cadastrar nova empresa (contratante)',
                });
              }}
            />
            <div className="filter-container">
              <div
                className="filter-content"
                onClick={(): void => {
                  onToggle();
                  onShouldShowModal({
                    value: ShouldShowModal.filter,
                    newTitleModal: '',
                  });
                }}
              >
                <FilterVector />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex pb-2 status-container">
          <div className="eventStatus subText">
            <Status style={{ color: '#7AD81B' }} />
            Contratante ativo
          </div>
          <div className="eventStatus subText">
            <Status style={{ color: colors.red }} />
            Contratante inativo
          </div>
        </div>
        <CustomTable
          columns={columnsContractor}
          data={dataTableContractor}
          numberRowsPerPage={currentPage.pageSize}
          progressPending={state === States.loading}
          theme="primary"
        />
        <Pagination
          currentPage={currentPage.page}
          totalCount={currentPage.total}
          pageSize={currentPage.pageSize}
          onPageChange={page => onPaginationChange(page)}
          total={currentPage.total}
        />
      </Container>
    </Fragment>
  );
};
